export default __webpack_public_path__ + "static/media/mindmantra.a6d61aba.png";